var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5645 0H7.95341C3.8534 0 0.519287 3.39738 0.519287 7.57035V21.4282C0.519287 25.6026 3.85478 28.9986 7.95341 28.9986H21.5645C25.6645 28.9986 28.9986 25.6012 28.9986 21.4282V7.57035C28.9986 3.39598 25.6631 0 21.5645 0ZM23.905 17.0024C23.905 19.3052 22.0709 21.1725 19.8091 21.1725H9.71018C7.44834 21.1725 5.61429 19.3052 5.61429 17.0024V11.9962C5.61429 9.69336 7.44834 7.82607 9.71018 7.82607H19.8091C22.0709 7.82607 23.905 9.69336 23.905 11.9962V17.0024Z",
    fill: "#3D2C06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8386 11.4429V14.5002V17.5576L15.3171 16.0289L17.797 14.5002L15.3171 12.9716L12.8386 11.4429Z",
    fill: "#3D2C06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bb7d26d22ddbf13c2d4f59c7424ff934.svg";
export { ForwardRef as ReactComponent };